import { DragOverlay } from "@dnd-kit/core"
import React, { PropsWithChildren } from "react"
// import {snapCenterToCursor, restrictToVerticalAxis} from "@dnd-kit/modifiers";

export const DraggableOverlay = (props: PropsWithChildren) => {
  return (
    <DragOverlay
      style={{
        marginLeft: '10px',
        minHeight: '30px',
      }}
      // modifiers={[snapCenterToCursor, restrictToVerticalAxis]}
    >
      {props.children}
    </DragOverlay>
  )
}
